export default __webpack_public_path__ + "static/media/Bologna.a9d68c42.jpg";